import { render, staticRenderFns } from "./DaftarBarangHilang.vue?vue&type=template&id=4cecf4ae&"
import script from "./DaftarBarangHilang.vue?vue&type=script&lang=js&"
export * from "./DaftarBarangHilang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports